import React from 'react';
import moment from 'moment';

import { TextField, Switch, MenuItem, FormControlLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import DialogWrapper from '../../../../../common/components/DialogWrapper/DialogWrapper';
import Utils from '../../../../../common/utils/Utils';
import PermissionsCheck from '../../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../../common/constants/PermissionsEnum';

const EditUser = (props) => (
  <DialogWrapper
    onClickCancel={props.showDialog.cancel}
    onClickMainAction={props.showDialog.action}
    open={props.showDialog.show}
    title={props.showDialog.title}
    disableMainAction={
      !props.selectedUser.Username ||
      !props.selectedUser.Email ||
      props.selectedUser.EmailErrorMessage !== '' ||
      props.selectedUser.UsernameErrorMessage !== '' ||
      props.selectedUser.AccountExpirationErrorMessage !== '' ||
      props.isSaving
    }
    maxWidth={'md'}
  >
    <div>
      <TextField
        variant="standard"
        data-qa="qa-usernameInput"
        label="Username"
        placeholder="Enter an alphanumeric value between 3 and 50 characters; for example: Username 01"
        error={props.selectedUser.UsernameErrorMessage !== ''}
        helperText={props.selectedUser.UsernameErrorMessage}
        value={props.selectedUser.Username}
        onChange={(e) => props.handleChangeFor('Username', e.target.value)}
        margin="normal"
        fullWidth
      />
      <TextField
        variant="standard"
        data-qa="qa-emailInput"
        label="Email"
        placeholder="Enter an email address in the form of address@domain.com."
        fullWidth={true}
        error={props.selectedUser.EmailErrorMessage !== ''}
        helperText={props.selectedUser.EmailErrorMessage}
        value={props.selectedUser.Email}
        onChange={(e) => props.handleChangeFor('Email', e.target.value)}
        disabled={!props.selectedUser.UserEntityId ? false : true}
        margin="normal"
      />
      <TextField
        variant="standard"
        data-qa="qa-role-input"
        select={true}
        label="Role"
        placeholder={!props.selectedUser.RoleEntity ? 'Select a role' : ''}
        hintStyle={{ opacity: 100 }}
        labelStyle={{ padding: 0 }}
        value={props.selectedUser.RoleEntity.Name}
        onChange={(e) => {
          props.onRoleSelected(e.target.value);
        }}
        style={{ width: '100%' }}
        margin="normal"
      >
        {props.roles.map((role) => (
          <MenuItem key={role.RoleEntityId} value={role.Name}>
            {role.Name}
          </MenuItem>
        ))}
      </TextField>

      {props.userPermissions.map((permission, index) => (
        <div>
          <PermissionsCheck permission={PermissionsEnum.ASSIGN_USER_PERMISSIONS}>
            <FormControlLabel
              style={{ margin: 0 }}
              label={permission.Name}
              labelPlacement="start"
              control={
                <Switch
                  data-qa={
                    props.selectedUser.Permissions.find((p) => p.Name === permission.Name) !==
                    undefined
                      ? `qa-user${permission.Name}Enabled`
                      : `qa-user${permission.Name}Disabled`
                  }
                  m={0}
                  labelStyle={{ width: '20%' }}
                  checked={
                    props.selectedUser.Permissions.find((p) => p.Name === permission.Name) !==
                    undefined
                  }
                  onChange={(e) => props.onPermissionSelected(permission.Name, e.target.checked)}
                />
              }
            />
          </PermissionsCheck>
          <PermissionsCheck
            permission={PermissionsEnum.ASSIGN_USER_PERMISSIONS}
            hasPermission={false}
          >
            <FormControlLabel
              style={{ margin: 0 }}
              label={permission.Name}
              labelPlacement="start"
              disabled={true}
              control={
                <Switch
                  data-qa={
                    props.selectedUser.Permissions.find((p) => p.Name === permission.Name) !==
                    undefined
                      ? `qa-user${permission.Name}Enabled`
                      : `qa-user${permission.Name}Disabled`
                  }
                  m={0}
                  labelStyle={{ width: '20%' }}
                  checked={
                    props.selectedUser.Permissions.find((p) => p.Name === permission.Name) !==
                    undefined
                  }
                />
              }
            />
          </PermissionsCheck>
        </div>
      ))}

      <FormControlLabel
        style={{ margin: 0 }}
        m={0}
        label="Account enabled"
        labelPlacement="start"
        control={
          <Switch
            data-qa={
              props.selectedUser.IsAccountEnabled
                ? 'qa-userAccountEnabled'
                : 'qa-userAccountDisabled'
            }
            m={0}
            checked={props.selectedUser.IsAccountEnabled}
            labelStyle={{ width: '20%' }}
            onChange={(e) => props.handleChangeFor('IsAccountEnabled', e.target.checked)}
          />
        }
      />
      <div>
        <DatePicker
          slotProps={{
            textField: () => ({
              'data-qa': 'qa-date-accountExpiration',
            }),
            actionBar: {
              // The actions will be the same between desktop and mobile
              actions: ['cancel', 'accept'],
            },
          }}
          className="u-mt-half"
          closeOnSelect={false}
          label="Account expiration date"
          placeholder="Account expiration date"
          value={moment.utc(props.selectedUser.AccountExpirationDate)}
          onAccept={(date) =>
            props.handleChangeFor('AccountExpirationDate', date.format('YYYY-MM-DDTHH:mm:ss'))
          }
          format={'YYYY-MM-DD'}
        />
      </div>
    </div>
  </DialogWrapper>
);

export default EditUser;
